import { Directive } from '@angular/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/yyyy',
  },
  display: {
    dateInput: 'MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'DD',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Directive({
  selector: '[appMonthYearDateDisplay]',
  providers: [provideLuxonDateAdapter(MY_FORMATS)],
})
export class MonthYearDateDisplayDirective {
  constructor() {}
}
